// 最大リトライ回数
export const MAX_RETRY_COUNT = 5;
// リトライ間隔の基本単位 (ミリ秒)
export const BASE_RETRY_DELAY = 1000;
// 追加される最大ジッター (ミリ秒)
export const MAX_RETRY_JITTER = 2000;

// DatePicker の最小年数
export const MIN_DATE_PICKER_YEAR = 2010;
export const MIN_DATE_PICKER_DATE = `${MIN_DATE_PICKER_YEAR}-01-01`;
